import React from 'react';
import PropTypes from 'prop-types';

const Card = ({ title, description, children }) => (
    <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-md border border-gray-200 dark:border-gray-700">
        <div className="p-6 border-b border-gray-200 dark:border-gray-700">
            <h2 className="text-xl font-bold text-gray-800 dark:text-gray-100">{title}</h2>
            {description && <p className="mt-1 text-gray-500 dark:text-gray-400">{description}</p>}
        </div>
        <div className="p-6">{children}</div>
    </div>
);

Card.propTypes = {
    title: PropTypes.string.isRequired,
    description: PropTypes.string,
    children: PropTypes.node.isRequired
};

export default React.memo(Card);
